module.exports = __webpack_public_path__ + "img/Pic_ZS_SJGL.066335b5.png";